var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "cleaningDrawer",
      attrs: {
        title: _vm.taskName + "-详细",
        "append-to-body": true,
        visible: _vm.cleaningDrawer,
        "wrapper-closable": false,
        size: "800px",
        "show-close": false,
        wrapperClosable: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.cleaningDrawer = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.waiting,
              expression: "waiting",
            },
          ],
          staticClass: "detailBox",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list.tableData,
            innerpage: "",
            "cell-class-name": _vm.cellClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "companyName", label: "企业名称", width: "228" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: scope.row.companyName,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "textOverflow" }, [
                          _vm._v(_vm._s(scope.row.companyName)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "legalPerson", label: "法人", width: "72" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.legalPerson || "--"))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "estiblishTime", label: "成立时间", width: "112" },
          }),
          _c("el-table-column", {
            attrs: { prop: "contactName", label: "联系人", width: "72" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.contactName || "--") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "contactInfo", label: "手机号", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    _vm.handlePhShow(scope.row.contactInfo),
                    function (item, index) {
                      return _c(
                        "span",
                        {
                          key: index + item,
                          on: {
                            click: function ($event) {
                              return _vm.onCopy(item)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "keyContact", label: "标签", width: "72" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.keyContact == 1 ? "关键人" : "--") +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "号码状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.cleaningState[scope.row.state] || "--") +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      this.list.tableData.length
        ? _c("pagination", {
            key: _vm.list.pageNum,
            attrs: {
              pageNum: _vm.list.pageNum,
              pageSize: _vm.list.pageSize,
              total: _vm.list.total,
            },
            on: {
              sizeChange: _vm.handleSizeChange,
              currentChange: _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }